import { put } from "redux-saga/effects";
import { serverRequest } from "../../actions";

export function* loadForm3(action) {
  var payload = {
    action: "portal/loadForm3",
    formId: action.formId,
    formDataId: action.formDataId,
  };

  yield put(serverRequest(payload));
}

export default loadForm3;
